import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  Flex,
  IconButton,
  Button,
  RowsTwoIcon,
  GridIcon,
  TextXS,
  GridItem,
  Grid,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  ChevronDownIcon,
  forwardRef,
} from "datastory-shared/ui"
import { useTranslation } from "datastory-shared/utils/i18n"

const sortByOptions = [
  { value: "desc", label: "A-Z" },
  { value: "asc", label: "Z-A" },
]

export const Controls = ({ setViewType, viewType, setSortBy, sortBy }) => {
  const sortByLabel = sortByOptions.find(i => i.value === sortBy).label

  const { t } = useTranslation()

  return (
    <Grid data-cy="controls">
      <GridItem colSpan={[4, 6, null, 12]}>
        <Flex
          mt={["sm", "sm", "lg"]}
          mb={"sm"}
          justifyContent={["center", "center", "space-between"]}
        >
          <Box display={["none", "none", "block"]}>
            <IconButton
              size="lg"
              onClick={() => setViewType("grid")}
              colorScheme="whiteAlpha"
              variant="outline"
              isActive={viewType === "grid"}
              icon={
                <GridIcon
                  color={viewType === "listing" ? "gray.900" : "primary.500"}
                  opacity={viewType === "listing" ? 0.6 : 1}
                />
              }
            />
            <IconButton
              size="lg"
              onClick={() => setViewType("listing")}
              colorScheme="whiteAlpha"
              variant="outline"
              isActive={viewType === "listing"}
              icon={
                <RowsTwoIcon
                  color={viewType === "listing" ? "primary.500" : "gray.900"}
                  opacity={viewType === "listing" ? 1 : 0.6}
                />
              }
            />
          </Box>

          <Flex alignItems="center">
            <Menu>
              <MenuButton
                mx="md"
                display="flex"
                alignItems="center"
                as={forwardRef((p, ref) => (
                  <Button variant="unstyled" ref={ref} {...p} />
                ))}
                rightIcon={<ChevronDownIcon boxSize="4" />}
              >
                <TextXS fontWeight={600} muted>{`${t("og_c:sort-by")}:
              ${sortByLabel.charAt(0).toUpperCase()}${sortByLabel.slice(1)}
            `}</TextXS>
              </MenuButton>
              <MenuList>
                {sortByOptions.map(({ value, label }) => (
                  <MenuItem
                    value={value}
                    key={value}
                    onClick={({ target }) => setSortBy(target.value)}
                  >
                    {label}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          </Flex>
        </Flex>
      </GridItem>
    </Grid>
  )
}

Controls.propTypes = {
  setViewType: PropTypes.func,
  setSortBy: PropTypes.func,
  sortBy: PropTypes.string,
  viewType: PropTypes.oneOf(["listing", "grid"]),
}
